import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  EditProfileContentContainer: {
    padding: theme.spacing(0)
  },
  EditProfileContent: {
    background: theme.palette.background.default,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(4),
    position: 'relative'
  }
}))

